<template>
  <span>
    Selezionando i posti che preferisci ti godrai un viaggio più comodo.
  </span>
</template>

<script>
export default {
  name: 'SelectionInstructions',
}
</script>
